export const channelProfiles = [
	{
		ID: 'standard-1080p-25-169',
		TITLE: '1080p 25fps',
	},
	{
		ID: 'standard-1080p-25-916',
		TITLE: '1080p 25fps (Vertical)',
	},
	{
		ID: 'standard-1080p-30-169',
		TITLE: '1080p 30fps',
	},
	{
		ID: 'standard-1080p-30-916',
		TITLE: '1080p 30fps (Vertical)',
	},
	{
		ID: 'standard-1080p-50-169',
		TITLE: '1080p 50fps',
	},
	{
		ID: 'standard-1080p-50-916',
		TITLE: '1080p 50fps (Vertical)',
	},
	{
		ID: 'standard-1080p-60-169',
		TITLE: '1080p 60fps',
	},
	{
		ID: 'standard-1080p-60-916',
		TITLE: '1080p 60fps (Vertical)',
	},
];
